import { Component, For, Show, onMount } from "solid-js";
import { RawHtml } from "./raw-html";
import { Img } from "./universal/image";
import { ads } from "../app";
import Carousel from 'carousel';

export const MainSlider : Component<any> = () => {
    onMount(() => {
        const carousel = new Carousel('.slick');
    })
    return (
        <div style="background-color: #333; color: darkgoldenrod;">
            <div class="slick" style="height: 100%;">
                <Show when={ads().length}>
                    <For each={ads()}>{(item, index) => 
                        <div class="slide" style={{ display: index() == 1 ? "block" : "none" }}>
                            <a class="outbound" href={item.URL}>
                                <figure style="margin: 0; padding: 0;">
                                    <Img
                                        src={item.Image.URL} width={951} height={301} mode="crop" format="JPG"
                                        class="img-responsive" style="width: 100%; max-height: 301px;"
                                    />
                                    <Show when={item.Text}>
                                        <figcaption><RawHtml value={item.Text} /></figcaption>
                                    </Show>
                                </figure>
                            </a>
                        </div>
                    }</For>
                </Show>
                <Show when={!ads().length}>
                    <div class="slide">
                        <figure style="margin: 0; padding: 0;">
                            <a href="/13thARCSalon/Home/PeoplesChoice">
                                <Img
                                    src="/Media/SalonResults/13thARCSalon/Sponsors/peoples Choice Award ad.jpg" 
                                    width={951} height={301} style="width: 100%; max-height: 301px;" mode="crop" class="img-responsive"
                                />
                            </a>
                        </figure>
                    </div>
                </Show>
            </div>
        </div>
    );
}